/* eslint-disable no-param-reassign */
import produce, {castDraft} from 'immer';

import {ReferenceFormatModel} from '../../../models/api/autolinkerModel';
import {StringOrTemplate} from '../commons/stringTemplateModel';
import {isExpressionAction} from '../expressions/expressionActions';
import {expressionReducer} from '../expressions/expressionReducer';
import {AutolinkerEditorAction, AutolinkerEditorActionTypesEnum} from './autolinkerEditorActions';
import {AutolinkerEditorState} from './autolinkerEditorState';

export function autolinkerEditorReducer(
  state: AutolinkerEditorState,
  action: AutolinkerEditorAction,
): AutolinkerEditorState {
  if (isExpressionAction(action)) {
    return expressionReducer(state, action, {});
  }

  switch (action.type) {
    case AutolinkerEditorActionTypesEnum.UPDATE_DESCRIPTION:
      return updateAutolinkerDescriptionReducer(state, action.description);

    case AutolinkerEditorActionTypesEnum.UPDATE_REFERENCE_FORMAT:
      return updateAutolinkerReferenceFormatReducer(state, action.referenceFormat);

    case AutolinkerEditorActionTypesEnum.UPDATE_URL_BUILDER:
      return updateAutolinkerUrlBuilderReducer(state, action.urlBuilder);

    default:
      return state;
  }
}

/*
 * Helpers.
 */

function updateAutolinkerDescriptionReducer(state: AutolinkerEditorState, description: string) {
  return produce(state, (draft) => {
    draft.autolinkerState.description = description;
  });
}

function updateAutolinkerReferenceFormatReducer(
  state: AutolinkerEditorState,
  referenceFormat: ReferenceFormatModel,
) {
  return produce(state, (draft) => {
    draft.autolinkerState.referenceFormat = castDraft(referenceFormat);
  });
}

function updateAutolinkerUrlBuilderReducer(state: AutolinkerEditorState, urlBuilder: StringOrTemplate) {
  return produce(state, (draft) => {
    draft.autolinkerState.urlBuilder = castDraft(urlBuilder);
  });
}
